<template>
  <div class="d-flex flex-column align-items-center justify-content-center h-100">
    <div class="btn-hover-times">
      <b-button
        class="btn__icon btn__icon--primary px-1 py-0"
        @click="$emit('hideItemLayout')"
      >
        <i
          class="fal fa-times"
          aria-hidden="true"
        />
      </b-button>
    </div>
    <div v-if="!item.disabled">
      <b-button
        class="button-transparent"
        @click="$emit('showPatientModal')"
      >
        <div class="item-header d-flex align-items-center justify-content-center">
          <i
            :class="item.icon"
            aria-hidden="true"
          />
        </div>
        <div class="item-text d-flex justify-content-center align-items-center text-center mt-1">
          <span>{{ $t(item.label) }}</span>
        </div>
      </b-button>
    </div>
    <div
      v-if="item.disabled"
      class="item-text d-flex justify-content-center align-items-center text-center"
    >
      <span>{{ $t('dashboard.widget.widgetNotAvailable') }}</span>
    </div>
  </div>
</template>

<script>
export default {
    name: 'LinkWidget',
    props: {
        item: { type: Object }
    }
}
</script>

<style scoped>

</style>
